import React from 'react';

export default function TrustSection() {
  const pillars = [
    {
      title: 'Role-Based Access Control',
      desc: 'Strict authorization rules isolate admin, teacher, student, and parent datasets for total privacy.',
      icon: '🛡️',
    },
    {
      title: 'Centralized Operational Management',
      desc: 'Single source of truth for user accounts, classes, timetables, attendance, and coursework grades.',
      icon: '🏛️',
      iconBg: 'bg-blue-500/10 text-blue-400',
    },
    {
      title: 'Instant PDF Document Export',
      desc: 'Generate official student report cards and attendance logs ready for printing or distribution.',
      icon: '📄',
      iconBg: 'bg-purple-500/10 text-purple-400',
    },
    {
      title: 'Cross-Device Responsiveness',
      desc: 'Optimized layout scaling smoothly from mobile phones and tablets to desktop monitors.',
      icon: '📱',
      iconBg: 'bg-emerald-500/10 text-emerald-400',
    },
  ];

  return (
    <section className="py-20 bg-slate-950 relative overflow-hidden border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <div className="text-xs font-bold uppercase tracking-widest text-blue-400 mb-2">
            ENTERPRISE FOUNDATION
          </div>
          <h2 className="font-serif text-2xl sm:text-4xl font-extrabold text-white tracking-tight">
            Built for Security, Performance & Scalability
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {pillars.map((p, idx) => (
            <div
              key={idx}
              className="bg-slate-900/60 border border-white/10 rounded-2xl p-6 hover:border-white/20 transition-all duration-300 flex flex-col justify-between"
            >
              <div>
                <div className="text-3xl mb-4 p-3 bg-white/5 rounded-xl w-fit border border-white/10">
                  {p.icon}
                </div>
                <h3 className="text-base font-bold text-white mb-2">{p.title}</h3>
                <p className="text-xs text-slate-400 leading-relaxed">{p.desc}</p>
              </div>
              <div className="mt-4 pt-3 border-t border-white/5 text-[11px] font-bold text-emerald-400">
                ✓ System Verified
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
